export default __webpack_public_path__ + "static/media/success.2048492d.svg";